import React, { useState } from 'react';
import { Switch, Route } from "react-router-dom";
import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Torus from "@toruslabs/torus-embed";
// Components
import Drawer from './components/Drawer';
import Header from './components/Header';
// Pages
import Home from './pages/Home';
import Ingredients from './pages/Ingredients';
import PantryItem from './pages/PantryItem';
import BidItem from './pages/BidItem';
import Recipes from './pages/Recipes';
import RecipeItem from './pages/RecipeItem';
import Stake from './pages/Stake';
import Claim from './pages/Claim';
import ClaimItem from './pages/ClaimItem';
// Context
import Web3context from './contexts/Web3context.js';

const App = () => {
  const [getWeb3, setWeb3] = useState(undefined);
  const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        rpc: {
          80001: "https://rpc-mumbai.matic.today"
        }
      }
    },
    torus: {
      package: Torus,
      options: {
        networkParams: {
          host: "mumbai",
          chainId: 80001,
          networkName: "Mumbai Test Network"
        },
        config: {
          buildEnv: "development"
        }
      }
    }
  };

  const web3Modal = new Web3Modal({
    cacheProvider: false,
    providerOptions
  });

  async function loginWeb3() {
    let provider = await web3Modal.connect()
    let w3 = new Web3(provider)
    setWeb3(w3)
    console.log(w3)
  }

  async function logoutWeb3() {
    web3Modal.clearCachedProvider();
    setWeb3(undefined)
  }

  function trimAdd(add = "0x00", l = 5) {
    return String(add).slice(0, 2) + String(add).slice(2, 2 + l) + "..." + String(add).slice(add.length - l, add.length)
  }

  return (
    <Web3context.Provider value={{ getWeb3, loginWeb3, logoutWeb3, trimAdd }}>
      <div className="outerSection_wrap">
        <Drawer />
        <div className="rightSideSection">
          <Header />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/ingredients" component={Ingredients} />
            <Route path="/pantryitem" component={PantryItem} />
            <Route path="/biditem" component={BidItem} />
            <Route path="/recipes" component={Recipes} />
            <Route path="/recipeitem" component={RecipeItem} />
            <Route path="/stake" component={Stake} />
            <Route path="/claim" component={Claim} />
            <Route path="/claimitem" component={ClaimItem} />
          </Switch>
        </div>
      </div>
    </Web3context.Provider>
  );
}

export default App;
